import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import React, { useMemo, useState } from 'react';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { AddOnIcons } from '../../../../utils';
import { AddOnType } from '~/types/models/addon';
import { Service } from '~/types/models';

const openRollUpLimitModalEventName = 'roll-up-limit-modal::open';
const closeRollUpLimitModalEventName = 'roll-up-limit-modal::close';

export const openRollUpLimitAddOnModal = () =>
  window.dispatchEvent(new CustomEvent(openRollUpLimitModalEventName));
export const closeRollUpLimitModal = () =>
  window.dispatchEvent(new CustomEvent(closeRollUpLimitModalEventName));

export interface RollUpLimitAddOnModalProps {
  onCtaClick?: () => void;
  monthlyPrice?: number;
}

export const RollUpLimitAddOnModal = ({
  onCtaClick,
  monthlyPrice,
}: RollUpLimitAddOnModalProps) => {
  const [open, setOpen] = useState(false);

  const onOpenRollUpLimitAddOnModal = useGlobalEvent(
    openRollUpLimitModalEventName as keyof WindowEventMap
  );

  const onCloseRollUpLimitAddOnModal = useGlobalEvent(
    closeRollUpLimitModalEventName as keyof WindowEventMap
  );

  onOpenRollUpLimitAddOnModal(() => setOpen(true));
  onCloseRollUpLimitAddOnModal(() => setOpen(false));

  const closeModal = () => setOpen(false);

  const modalProps = useMemo<ModalProps>(() => {
    return {
      open,
      onModalClose: closeModal,
      closeButtonClassName: '!w-5',
      className: '!w-[500px] !inset-px !p-7',
    };
  }, [open]);

  return (
    <Modal {...modalProps}>
      <div className='flex flex-col gap-y-5 items-center'>
        <img
          src={AddOnIcons[AddOnType.LimitGreetRollUp][Service.VideoMessaging]}
          width='50'
          height='50'
        />
        <h4 className='text-[21px] v2-text-neutral-900 font-bold m-0 font-circular'>
          Growth lite add-on
        </h4>
        <p className='text-base v2-text-neutral-900 text-center leading-5 mb-0'>
          Get Roll-ups and remove Bonjoro badge from your video landing pages
          for ${monthlyPrice} USD per month. We will be adding the charge to
          your saved payment method.
        </p>
        <div className='flex flex-col gap-y-3 md:flex-row md:gap-x-4'>
          <Button
            className='py-1.5 text-base'
            variant={ButtonVariant.Primary}
            onClick={onCtaClick}
          >
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};
